"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgMoon = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M23.182 24.818a8.002 8.002 0 01-1.866-8.38 8 8 0 1010.247 10.247 8.002 8.002 0 01-8.38-1.867zm10.814.064a10 10 0 11-10.878-10.878c.86-.08 1.41.896.896 1.59a6 6 0 008.392 8.392c.694-.514 1.67.036 1.59.896z",
    id: "moon_svg__a"
  }));
};

var _default = SvgMoon;
exports.default = _default;